import {IRegulationPresetValues} from '../regulation-preset-values.interface';

export const DENMARK_PRESETS_VALUES: IRegulationPresetValues = {
    sdk: {
        Skin: {
            regulationID: 8,
            brandID: 75,
            subBrandID: 113
        },
        Currency: {
            anonymousCurrency: 'DKK'
        }
    },
    orbit: {
        country: 'dnk',
        language: 'dan',
        iso2: 'da',
        publicationID: 1867,
        cmsSource: 'https://www.888casino.dk'
    }
}